import { render, staticRenderFns } from "./BdMonitor.vue?vue&type=template&id=94217936&"
import script from "./BdMonitor.vue?vue&type=script&lang=js&"
export * from "./BdMonitor.vue?vue&type=script&lang=js&"
import style0 from "./BdMonitor.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports